import { ref, reactive, watch } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-197164ff"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wechat-content"
};
const _hoisted_2 = {
  class: "flex-content"
};
const __default__ = {
  name: 'WxNativePay'
};
import SvgIcon from '@/components/SvgIcon.vue';
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    rules: {},
    detailForm: {}
  },
  emits: ['submitForm'],
  setup(__props, {
    expose,
    emit
  }) {
    const props = __props;
    const nativeRef = ref();
    const nativeForm = reactive({
      pkg: '',
      appId: '',
      mchId: null,
      apiKey: '',
      mchName: '',
      merchants: '',
      wxPriKey: '',
      apiKeyV3: '',
      certSerialNo: '',
      appSecret: '',
      rate: 0.009
    });
    const channelRateList = ref([]); // 费率列表
    const validateForm = () => {
      var _nativeRef$value;
      (_nativeRef$value = nativeRef.value) === null || _nativeRef$value === void 0 || _nativeRef$value.validate().then(() => {
        emit('submitForm', nativeForm);
      }).catch(e => void 0);
    };
    watch(() => props.detailForm, n => {
      if (n) {
        nativeForm.pkg = n.pkg;
        nativeForm.appId = n.appId;
        nativeForm.mchId = n.mchId;
        nativeForm.apiKey = n.apiKey;
        nativeForm.mchName = n.mchName;
        nativeForm.merchants = n.merchants;
        nativeForm.wxPriKey = n.wxPriKey;
        nativeForm.apiKeyV3 = n.apiKeyV3;
        nativeForm.certSerialNo = n.certSerialNo;
        nativeForm.appSecret = n.appSecret;
        channelRateList.value = n.channelRateList;
        nativeForm.rate = n.channelRate;
      }
    }, {
      immediate: true,
      deep: true
    });
    expose({
      validateForm
    });
    return (_ctx, _cache) => {
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_form_item = _resolveComponent("a-form-item");
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_tooltip = _resolveComponent("a-tooltip");
      const _component_a_form = _resolveComponent("a-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_a_form, {
        model: nativeForm,
        ref_key: "nativeRef",
        ref: nativeRef,
        rules: __props.rules,
        name: "native-validate"
      }, {
        default: _withCtx(() => [_createVNode(_component_a_form_item, {
          name: "pkg",
          label: "包名："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: nativeForm.pkg,
            "onUpdate:value": _cache[0] || (_cache[0] = $event => nativeForm.pkg = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "appId",
          label: "appId："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: nativeForm.appId,
            "onUpdate:value": _cache[1] || (_cache[1] = $event => nativeForm.appId = $event),
            valueModifiers: {
              trim: true
            },
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "mchName",
          label: "商户主体："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: nativeForm.mchName,
            "onUpdate:value": _cache[2] || (_cache[2] = $event => nativeForm.mchName = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "merchants",
          label: "商户号："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_select, {
            value: nativeForm.merchants,
            "onUpdate:value": _cache[3] || (_cache[3] = $event => nativeForm.merchants = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "apiKeyV3",
          label: "API key V3："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: nativeForm.apiKeyV3,
            "onUpdate:value": _cache[4] || (_cache[4] = $event => nativeForm.apiKeyV3 = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "certSerialNo",
          label: "证书序列号："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: nativeForm.certSerialNo,
            "onUpdate:value": _cache[5] || (_cache[5] = $event => nativeForm.certSerialNo = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "wxPriKey",
          label: "wx_pri_key："
        }, {
          default: _withCtx(() => [_createVNode(_component_a_input, {
            value: nativeForm.wxPriKey,
            "onUpdate:value": _cache[6] || (_cache[6] = $event => nativeForm.wxPriKey = $event),
            disabled: ""
          }, null, 8, ["value"])]),
          _: 1
        }), _createVNode(_component_a_form_item, {
          name: "rate",
          label: "费率："
        }, {
          default: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_a_select, {
            value: nativeForm.rate,
            "onUpdate:value": _cache[7] || (_cache[7] = $event => nativeForm.rate = $event),
            options: channelRateList.value
          }, null, 8, ["value", "options"]), _createVNode(_component_a_tooltip, {
            placement: "right"
          }, {
            title: _withCtx(() => [_createTextVNode("使用微信支付功能将收取0.9%手续费")]),
            default: _withCtx(() => [_createVNode(SvgIcon, {
              "icon-class": "questionMark",
              "class-name": "question-icon"
            })]),
            _: 1
          })])]),
          _: 1
        })]),
        _: 1
      }, 8, ["model", "rules"])]);
    };
  }
});